import { handleActions } from 'redux-actions';
// import { types } from '../constants';
import { types, inputFieldNames } from '../constants';

const INITIAL_STATE = {
  newPersonnel: {
    showCreatePersonnelDialog: false,
    isShortPersonnelDialog:false,
    showEditPersonnelDialog: false,
    showDeletePersonnelDialog: false,
    item: {
      startDateUTC: null,
      regDateUTC: null
    },
    isSaving: false,
    errorMessage: '',
    validationState: true
  },
  personnel: {
    item: null,
    isLoading: false,
    errorMessage: ''
  },
  deleteOrDeactivatingPersonnel: {
    open: false,
    isSaving: false,
    personnelId: 0,
    errorMessage: '',
    status: 0,
    item: {}
  },
  coursesForPersonnel: {
    items: [],
    isLoading: false,
    errorMessage: '',
    selectedPersonnel: null,
    dialogOpen: false
  }
};

const openCreatePersonnelDialog = (state, { open, isShort }) => {
  return {
    ...state,
    newPersonnel: {
      ...state.newPersonnel,
      showCreatePersonnelDialog: open,
      isShortPersonnelDialog: isShort,
      item: {
        startDateUTC: null,
        regDateUTC: null
      },
      validationState: true
    }
  };
};

const openEditPersonnelDialog = (state, { open }) => {
  return {
    ...state,
    newPersonnel: {
      ...state.newPersonnel,
      showEditPersonnelDialog: open,
      item: {}
    }
  };
};

const openDeletePersonnelDialog = (state, { open }) => {
  return {
    ...state,
    newPersonnel: {
      ...state.newPersonnel,
      showDeletePersonnelDialog: open,
      item: {}
    }
  };
};

const inputChangeCreateEditPersonnelForm = (
  state,
  { value, inputFieldName }
) => {
  const personnel = { ...state.newPersonnel.item };
  switch (inputFieldName) {
    case inputFieldNames.FIRST_NAME:
      personnel.firstName = value;
      break;
    case inputFieldNames.LAST_NAME:
      personnel.lastName = value;
      break;
    case inputFieldNames.WORK_PHONE:
      personnel.workPhone = value;
      break;
    case inputFieldNames.BRANCH:
      personnel.branchId = parseInt(value);
      break;
    case inputFieldNames.NOTES:
      personnel.notes = value;
      break;
    case inputFieldNames.START_DATE_UTC:
      personnel.startDateUTC = value;
      break;
    case inputFieldNames.HOME_PHONE:
      personnel.homePhone = value;
      break;
    case inputFieldNames.ASSIGNEE:
      personnel.assignee = value;
      break;
    case inputFieldNames.REQUESTOR:
      personnel.requestor = value;
      break;
    case inputFieldNames.REG_DATE_UTC:
      personnel.regDateUTC = value;
      break;
    case inputFieldNames.SITE:
      personnel.siteId = parseInt(value);
      break;
    default:
      break;
  }

  return {
    ...state,
    newPersonnel: {
      ...state.newPersonnel,
      item: personnel
    }
  };
};

const changeNewPersonnelValidationState = (state, { validationState }) => {
  return {
    ...state,
    newPersonnel: {
      ...state.newPersonnel,
      validationState
    }
  };
};

const startSubmitPersonnel = (state) => {
  return {
    ...state,
    newPersonnel: {
      ...state.newPersonnel,
      isSaving: true
    }
  };
};

const submitPersonnelesuccess = (state, { submittedPersonnel }) => {
  return {
    ...state,
    personnel: {
      ...state.Personnel,
      item: submittedPersonnel
    }
  };
};

const submitPersonnelFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newPersonnel: {
      ...state.newPersonnel,
      errorMessage
    }
  };
};

const submitPersonnelFinished = (state) => {
  return {
    ...state,
    newPersonnel: {
      ...state.newPersonnel,
      isSaving: false
    }
  };
};

const editPersonnel = (state, { personnel }) => {
  return {
    ...state,
    newPersonnel: {
      ...state.newPersonnel,
      item: personnel
    }
  };
};

const openCoursesForPersonnelDialog = (state, { open, personnel }) => {
  return {
    ...state,
    coursesForPersonnel: {
      ...state.coursesForPersonnel,
      dialogOpen: open,
      selectedPersonnel: personnel
    }
  };
};

const clearAllCoursesForPersonnel = (state) => {
  return {
    ...state,
    coursesForPersonnel: {
      ...state.coursesForPersonnel,
      items: []
    }
  };
};

const startFetchCoursesForPersonnel = (state) => {
  return {
    ...state,
    coursesForPersonnel: {
      ...state.coursesForPersonnel,
      isLoading: true
    }
  };
};

const fetchCoursesForPersonnelSuccess = (state, { coursesForPersonnel }) => {
  return {
    ...state,
    coursesForPersonnel: {
      ...state.coursesForPersonnel,
      items: coursesForPersonnel
    }
  };
};

const openCoursesForPersonnelDialogFailure = (state, { errorMessage }) => {
  return {
    ...state,
    coursesForPersonnel: {
      ...state.coursesForPersonnel,
      errorMessage
    }
  };
};

const openCoursesForPersonnelDialogFinished = (state) => {
  return {
    ...state,
    coursesForPersonnel: {
      ...state.coursesForPersonnel,
      isLoading: false
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.OPEN_CREATE_PERSONNEL_DIALOG]: openCreatePersonnelDialog,
    [types.OPEN_EDIT_PERSONNEL_DIALOG]: openEditPersonnelDialog,
    [types.OPEN_DELETE_PERSONNEL_DIALOG]: openDeletePersonnelDialog,

    [types.INPUT_CHANGE_CREATE_PERSONNEL_FORM]: inputChangeCreateEditPersonnelForm,
    [types.CHANGE_NEW_PERSONNEL_VALIDATION_STATE]: changeNewPersonnelValidationState,

    [types.START_SUBMIT_PERSONNEL]: startSubmitPersonnel,
    [types.SUBMIT_PERSONNEL_SUCCESS]: submitPersonnelesuccess,
    [types.SUBMIT_PERSONNEL_FAILURE]: submitPersonnelFailure,
    [types.SUBMIT_PERSONNEL_FINISHED]: submitPersonnelFinished,

    [types.EDIT_PERSONNEL]: editPersonnel,

    [types.OPEN_COURSES_FOR_PERSONNEL_DIALOG]: openCoursesForPersonnelDialog,
    [types.CLEAR_ALL_COURSES_FOR_PERSONNEL]: clearAllCoursesForPersonnel,

    [types.START_FETCH_COURSES_FOR_PERSONNEL]: startFetchCoursesForPersonnel,
    [types.FETCH_COURSES_FOR_PERSONNEL_SUCCESS]: fetchCoursesForPersonnelSuccess,
    [types.FETCH_COURSES_FOR_PERSONNEL_FAILURE]: openCoursesForPersonnelDialogFailure,
    [types.FETCH_COURSES_FOR_PERSONNEL_FINISHED]: openCoursesForPersonnelDialogFinished
  },
  INITIAL_STATE
);
